var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-detail-wrapper p-0"},[_c('h4',[_vm._v("Telkom Product Tree")]),_c('b-card',{staticClass:"mt-2 pt-3",staticStyle:{"overflow-y":"auto"}},[_c('TreeChart',{attrs:{"json":_vm.treeData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }